import script from "./TourView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TourView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__